import React from 'react';

import { Field, ErrorMessage } from 'formik';

export default function MessageCheckbox(props) {
  const { name } = props;

  return (
    <Field name={name}>
      {({ field, form }) => {
        const { name,  value } = field;
        const { setFieldValue } = form;

        return (
          <p>
            <label>
              <input
                type="checkbox"
                name={name}
                value={value}
                checked={value}
                onChange={() => setFieldValue(name, !value)}
                id={name}
              />
              <span /> By clicking confirm payment you have our guarantee and
              agree with our{' '}
              <a
                href="/policies/terms-services"
                target="_blank"
                rel="noopener noreferrer"
                style={{color: 'rgb(0, 192, 255)'}}
              >
                terms and conditions.
              </a>{' '}
              Thank you for trusting our services.
            </label>
            <ErrorMessage name={name}>
              {error => <div className="error">{error}</div>}
            </ErrorMessage>
          </p>
        );
      }}
    </Field>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Flights/PassengerDetails/MessageCheckbox.js